import scriptModule from "./scriptModule"
const scriptView = require("text!./scriptView.html")

scriptModule.config(["editionServiceProvider", (editionServiceProvider: any) => {
    editionServiceProvider.registerEdition("script", scriptView, "scriptController", "group.r2.configuration.advanced")
}])